import { RDEqipEligibilityConservationCSP } from '@cibo/core'
import { ResourceDetailFeature, ResourceDetailFeatureTaskEditorProps } from '@cibo/ui'
import { SelectRollupEditor } from '../../SelectRollupEditor'
import { EQIP_PRACTICES_CONSERVATION, EqipPracticesConservation } from './types'

export const RDEqipEligibilityConservationCSPResourceDetailFeature: ResourceDetailFeature<RDEqipEligibilityConservationCSP> =
  {
    traitId: 'eqipEligibilityConservationCSP',
    TaskEditor: (props: ResourceDetailFeatureTaskEditorProps<RDEqipEligibilityConservationCSP>) => (
      <SelectRollupEditor<RDEqipEligibilityConservationCSP, readonly EqipPracticesConservation[]>
        options={EQIP_PRACTICES_CONSERVATION}
        detailKey="cspEnrolled"
        ns="@cibo/landmanager/RDEqipEligibilityConservationCSPResourceDetailFeature"
        {...props}
      />
    ),
  }
